//require('dotenv').config();

import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

import "../../index.css";
import '../../output.css';

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

import ".././waitlist.css"; // <-- add this

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5050";

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default function WaitlistPage() {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [combo, setCombo] = useState("emailOnly"); // default so the UI shows immediately
  const [status, setStatus] = useState(null);
  const [refID, setRefID] = useState("");
  const [refBy, setRefBy] = useState("");
  const [shareLink, setShareLink] = useState("");

  const [open, setOpen] = useState(false); // NEW

  var isMobile = useIsMobile();

  const postMongo = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch(`${API_BASE}/api/waitlist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email || undefined,
          phone: phone || undefined,
          combo,
          refID: refBy || undefined,
        }),
      });

      const data = await res.json();

      if (data.refID) {
        setRefID(data.refID);
        setShareLink(`${window.location.origin}/home?ref=${data.refID}`);
      }

      if (!res.ok) {
        throw new Error(data.error || "Something went wrong");
      }

      if (data.position) {
        setStatus(`${data.message} You’re #${data.position} in line.`);
      } else {
        setStatus(data.message || "Success!");
      }

      setEmail("");
      // keep phone as-is or clear it; your call:
      // setPhone("");
    } catch (err) {
      setStatus(err.message);
    }
  };

  const showEmail = combo === "emailOnly" || combo === "combined";
  const showPhone = combo === "phoneOnly" || combo === "combined";
  const isLoading = status === "loading";

  return (

<div
  className="wl__modalOverlay"
  role="dialog"
  aria-modal="true"
  aria-label="Join the waitlist"
  onMouseDown={(e) => {
    if (e.target === e.currentTarget) setOpen(false);
  }}
>
  <div className="wl__modal">
    <Link to={"/"}
      type="button"
      className="wl__modalClose"
      aria-label="Close"
    >
      ✕
    </Link>

    {/* POPUP CONTENT: EXACTLY YOUR PANEL, UNCHANGED */}
    <div className="wl__panel">
      <div className="wl__panelTop">
        <div className="wl__panelTitle">Join the waitlist</div>
        {refBy ? (
          <div className="wl__ref">
            Referred by <span className="wl__refCode">{refBy}</span>
          </div>
        ) : (
          <div className="wl__ref wl__refMuted">
            Have a referral link? It’ll apply automatically.
          </div>
        )}
      </div>

      <form className="wl__form" onSubmit={postMongo}>
        {/* segmented control */}
        <div className="wl__seg" role="tablist" aria-label="Contact method">
          {[
            { key: "emailOnly", label: "Email" },
            { key: "phoneOnly", label: "Phone" },
            { key: "combined", label: "Both" },
          ].map((opt) => (
            <button
              key={opt.key}
              type="button"
              className={`wl__segBtn ${combo === opt.key ? "isActive" : ""}`}
              onClick={() => setCombo(opt.key)}
            >
              {opt.label}
            </button>
          ))}
        </div>

        {/* inputs */}
        <div className="wl__fields">
          {showEmail && (
            <div className="wl__field">
              <label className="wl__label" htmlFor="wl-email">
                Email
              </label>
              <input
                id="wl-email"
                type="email"
                placeholder="you@domain.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="wl__input"
                autoComplete="email"
              />
            </div>
          )}

          {showPhone && (
            <div className="wl__field">
              <label className="wl__label">Phone</label>
              <div className="wl__phoneWrap">
                <div className="wl__phoneShell">
                  <PhoneInput
                    country={"us"}
                    preferredCountries={["us"]}
                    value={phone}
                    onChange={setPhone}
                    inputClass="wl__phoneInput"
                    buttonClass="wl__phoneButton"
                    containerClass="wl__phoneContainer"
                    dropdownClass="wl__phoneDropdown"
                    placeholder="(555) 555-5555"
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* CTA */}
        <button
          type="submit"
          className="wl__cta"
          disabled={isLoading || (!showEmail && !showPhone)}
        >
          {isLoading ? "Submitting…" : "Join waitlist"}
        </button>

        {/* status */}
        {status && (
          <div className={`wl__status ${isLoading ? "isLoading" : ""}`}>
            {isLoading ? "Submitting…" : status}
          </div>
        )}

        {/* referral share */}
        {shareLink && (
          <div className="wl__share">
            <div className="wl__shareTop">
              <div className="wl__shareTitle">You’re in.</div>
              <div className="wl__shareSub">
                Share your link to move up the line.
              </div>
            </div>

            <div className={`wl__shareRow ${isMobile ? "isMobile" : ""}`}>
              <input className="wl__shareInput" value={shareLink} readOnly />
              <button
                type="button"
                className="wl__copyBtn"
                onClick={async () => {
                  try {
                    await navigator.clipboard.writeText(shareLink);
                    setStatus("Copied referral link ✅");
                  } catch (err) {
                    // fallback
                    try {
                      const ta = document.createElement("textarea");
                      ta.value = shareLink;
                      ta.style.position = "fixed";
                      ta.style.left = "-9999px";
                      document.body.appendChild(ta);
                      ta.focus();
                      ta.select();
                      const ok = document.execCommand("copy");
                      document.body.removeChild(ta);
                      setStatus(
                        ok
                          ? "Copied referral link ✅"
                          : "Copy failed. select & copy manually."
                      );
                    } catch {
                      setStatus("Copy failed. select & copy manually.");
                    }
                  }
                }}
              >
                Copy
              </button>
            </div>

            {refID && (
              <div className="wl__shareFoot">
                Your code: <b>{refID}</b>
              </div>
            )}
          </div>
        )}
      </form>

      <div className="wl__privacy">
        We only use this to notify you about launch & invites. We don't
        sell your info.
      </div>
    </div>
  </div>
</div>
)}
